import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserMfaEngageOutput } from 'user/model/user-mfa-engage.output';
import { userMfaEngage } from 'user/model/user.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';

@Injectable({ providedIn: 'root' })
export class GenerateUserMfaApiMutation extends ApiMutation<
	UserMfaEngageOutput,
	void
> {
	client = 'iam';
	document = gql`
		mutation GenerateUserMfa {
			generateUserMfa {
				...UserMfaEngage
			}
		}
		${userMfaEngage}
	`;
	method = 'generateUserMfa';
}
